/*
生成语音
*/

import CryptoJS from "crypto-js";

import { cleanMarkdown } from "./cleanMarkdown";
import BaseURL from "../../../../NetComponents/BaseURL";


// 使用md5计算文本的hash值
const hashText = (text) => {
    return CryptoJS.MD5(text).toString();
};

// 使用map作为缓存，刷新就没了
const audioCache = new Map();

const getCachedAudioURL = (hash) => {
    return audioCache.get(hash) || null;
};

const saveCachedAudioURL = (hash, audioBlob) => {
    const audioUrl = URL.createObjectURL(audioBlob);
    audioCache.set(hash, audioUrl);
    return audioUrl;
};

// 主函数：获取音频URL（可能来自缓存）
export const generateVoice = async (voiceMessage) => {
    // 处理markdown文本
    const text = cleanMarkdown(voiceMessage);
    const hash = hashText(text);

    // 尝试从缓存中获取
    let cachedURL = getCachedAudioURL(hash);
    if (cachedURL) {
        return cachedURL;
    }

    // 请求后端语音合成
    const response = await BaseURL.post("api/chat/voice/", {
        text: text,
        filename: hash
    }, {
        responseType: "blob",
    });

    const audioBlob = new Blob([response.data], { type: "audio/wav" });
    return saveCachedAudioURL(hash, audioBlob);
};